function Erroricon() {
    return (
        <svg width="14" height="15" viewBox="0 0 14 15" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 .5a7 7 0 1 1 0 14 7 7 0 0 1 0-14zm0 9.625a.875.875 0 1 0 0 1.75.875.875 0 0 0 0-1.75zm0-7A.875.875 0 0 0 6.125 4v3.5a.875.875 0 1 0 1.75 0V4A.875.875 0 0 0 7 3.125z" fill="#EEE" fillRule="nonzero"/>
        </svg>
    );
}

export default Erroricon;
